// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Col, Container, Row } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import {
  ToggleFavorite,
  useFavorite,
} from '../../../plugins/gatsby-plugin-favorites/src';
import useLink from '../../useLink';
import BrandLogo, { BrandLogoFragments } from '../Brand/BrandLogo';
import ExhibitorHeader, {
  ExhibitorHeaderFragment,
} from '../Exhibitor/ExhibitorHeader';
import ChangeExhibitorLink from './ChangeExhibitorLink';

/**
 *
 * @param {object} props
 * @param {{ exhibitorId: string; name?: string; registrationId: string; }} props.exhibitor
 * @param {object} [props.previous]
 * @param {object} [props.next]
 */
export default function ExhibitorHeaderRow({ exhibitor, previous, next }) {
  const link = useLink();
  // TODO use registrationId: exhibitor.registrationId,
  const favorite = useFavorite(
    exhibitor && { type: 'registration', id: exhibitor.exhibitorId }
  );
  return (
    <Container>
      <Row sx={{ justifyContent: 'center' }}>
        <Col sx={{ marginTop: [-75, -50] }}>
          <BrandLogo
            size="large"
            brand={exhibitor}
            sx={{ backgroundColor: 'background' }}
          />
        </Col>
        <Col
          sx={{
            paddingY: 4,
            flex: '1',
            minWidth: ['100%', 'unset'],
            order: [1, 'unset'],
          }}
        >
          <ExhibitorHeader as="h1" exhibitor={exhibitor} gap={3} />
          <ToggleFavorite
            sx={{ marginTop: 3, marginLeft: -2, padding: 0, paddingRight: 3 }}
            isToggled={favorite.isSet}
            onClick={favorite.toggle}
          />
        </Col>
        <Col sx={{ order: -1, minWidth: `${100 / 12}%`, textAlign: 'right' }}>
          <ChangeExhibitorLink
            exhibitor={previous}
            to={link.exhibitor(previous)}
            direction="previous"
            sx={{ marginLeft: -4, marginRight: -3, marginTop: 3 }}
          />
        </Col>
        <Col sx={{ minWidth: `${100 / 12}%` }}>
          <ChangeExhibitorLink
            exhibitor={next}
            to={link.exhibitor(next)}
            sx={{ marginLeft: -3, marginRight: -4, marginTop: 3 }}
          />
        </Col>
      </Row>
    </Container>
  );
}

export const fragment = graphql`
  fragment ExhibitorHeaderRow on Exhibitor {
    exhibitorId
    name
    ...BrandLogoLarge
    ...ExhibitorHeader
    ...useLink_Exhibitor
  }
`;

export const ExhibitorHeaderRowFragment = gql`
  ${BrandLogoFragments.large}
  ${ExhibitorHeaderFragment}
  fragment ExhibitorHeaderRow on Exhibitor {
    exhibitorId
    name
    ...BrandLogoLarge
    ...ExhibitorHeader
  }
`;
